import { useCallback, useSyncExternalStore } from 'react';
import { normalizePreferences, preferenceKey, readPreferences, writePreferences } from './preferences';

const snapshots = new Map();
const CHANGE_EVENT = 'parseeker-home-eagle-change';
const snapshot = userId => {
  const key = preferenceKey(userId);
  if (!snapshots.has(key)) snapshots.set(key, { preferences: readPreferences(userId), saveError: false });
  return snapshots.get(key);
};

// Shared by Home, Settings, and any previews. Unsaved choices survive in-app navigation.
export const useEaglePreferences = userId => {
  const key = preferenceKey(userId);
  const getSnapshot = useCallback(() => snapshot(userId), [userId]);
  const subscribe = useCallback(notify => {
    const reload = () => {
      const next = { preferences: readPreferences(userId), saveError: false };
      if (JSON.stringify(snapshot(userId)) !== JSON.stringify(next)) snapshots.set(key, next);
    };
    if (!snapshot(userId).saveError) reload();
    const onChange = event => { if (event.detail.key === key) notify(); };
    const onStorage = event => {
      if (event.key !== null && event.key !== key) return;
      if (event.storageArea && event.storageArea !== window.localStorage) return;
      reload(); notify();
    };
    window.addEventListener(CHANGE_EVENT, onChange);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(CHANGE_EVENT, onChange);
      window.removeEventListener('storage', onStorage);
    };
  }, [key, userId]);
  const state = useSyncExternalStore(subscribe, getSnapshot);
  const update = useCallback(changes => {
    const preferences = normalizePreferences({ ...snapshot(userId).preferences, ...changes });
    const saveError = !writePreferences(userId, preferences);
    snapshots.set(key, { preferences, saveError });
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { key } }));
  }, [key, userId]);
  return { ...state, update };
};